import { Skeleton } from '@/_components';
import { CardContainer } from '@/_containers';

export function HeaderLoading() {
  return (
    <CardContainer className="pb-2">
      <section className="flex flex-1 items-center justify-center gap-4">
        <div className="absolute top-8 left-8 flex flex-col gap-1">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-4 w-24" />
        </div>

        <div className="absolute top-8 right-8">
          <Skeleton className="h-7 w-24" />
        </div>

        <div className="mt-12 flex flex-col items-center pb-6">
          <Skeleton className="mt-1 h-7 w-36" />
          <Skeleton className="mt-1 h-5 w-44" />
        </div>
      </section>
    </CardContainer>
  );
}
